import { c as _c } from "react/compiler-runtime";
import { ErrorMessage, Icon } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import clsx from "clsx";
import de from "date-fns/locale/de";
import { ComponentProps, FC } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import styles from "./MonthInput.module.css";
registerLocale("de", de);
setDefaultLocale("de");
export interface MonthInputProps extends Pick<ComponentProps<typeof DatePicker>, "onBlur" | "maxDate"> {
  onChange: (date: Date | null) => void;
  value?: Date;
  label?: string;
  errorMessage?: string;
  placeholder?: string;
}
const MonthInput: FC<MonthInputProps> = t0 => {
  const $ = _c(20);
  const {
    label,
    maxDate,
    onChange,
    onBlur,
    value,
    errorMessage,
    placeholder
  } = t0;
  const locale = useLanguage();
  let t1;
  if ($[0] !== label) {
    t1 = <label className="text-title-1 flex mb-xs">{label}</label>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <input inputMode="none" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("bg-neutral-0 shadow-3 rounded-m p-s m:p-m border border-neutral-25", styles.calendar);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon type="Left" size="20" className="p-3xs text-primary-800" />;
    t5 = <Icon type="Right" size="20" className="p-3xs text-primary-800" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon type="Calendar" size="20" className="absolute pointer-events-none top-1/2 -translate-y-1/2 right-s text-neutral-150" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== locale || $[8] !== maxDate || $[9] !== onBlur || $[10] !== onChange || $[11] !== placeholder || $[12] !== value) {
    t7 = <DatePicker locale={locale} placeholderText={placeholder} onBlur={onBlur} wrapperClassName="relative" customInput={t2} className="text-button-1 m:text-body-2 rounded-s border transition-colors ease-out flex items-center text-inherit px-s py-[11px] border-neutral-50 text-neutral-575 hover:border-neutral-100 focus:border-neutral-100 placeholder:text-neutral-150 focus-visible:outline-none w-full" calendarClassName={t3} popperClassName="z-50 py-2xs" showPopperArrow={false} monthClassName={_temp} previousYearButtonLabel={t4} nextYearButtonLabel={t5} showIcon={true} icon={t6} selected={value} onChange={onChange} dateFormat="MM.yyyy" maxDate={maxDate} showMonthYearPicker={true} showFullMonthYearPicker={true} />;
    $[7] = locale;
    $[8] = maxDate;
    $[9] = onBlur;
    $[10] = onChange;
    $[11] = placeholder;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== errorMessage) {
    t8 = errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>;
    $[14] = errorMessage;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div>{t1}{t7}{t8}</div>;
    $[16] = t1;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default MonthInput;
function _temp() {
  return "text-body-2 inline-block text-center cursor-pointer hover:bg-neutral-25 aria-selected:bg-primary-800 aria-selected:text-neutral-0 rounded-full p-2xs focusable";
}